module.exports = __webpack_public_path__ + "static/img/ios1.3.439b876c.jpg";